var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GradientInput',{attrs:{"value":_vm.hexValue,"label":"HEX","onFocus":() => (_vm.inProgress = true),"onBlur":() => (_vm.inProgress = false),"inProgress":_vm.inProgress,"classes":"hex"},on:{"input":_vm.changeHex}})
}
var staticRenderFns = []

export { render, staticRenderFns }